import React from 'react';
import {Confirm as ConfirmComponent} from '@unthinkable/react-confirm';

export const Confirm = props => {
  return <ConfirmComponent {...props} />;
};
